import BoundingBox from 'boundingbox';

export const getCentroidFromSearchCookie = (
    cookie: string
): { lat: number; lon: number } | null => {
    try {
        const coordChars = '([\\d-.]*)';
        const result = new RegExp(
            `rect=${coordChars}%2C${coordChars}%2C${coordChars}%2C${coordChars}&`
        ).exec(cookie);

        const [, minlat, minlon, maxlat, maxlon] = result ?? [];

        if (!minlat || !minlon || !maxlat || !maxlon) {
            return null;
        }

        const boundingRect = new BoundingBox({
            minlat: parseFloat(minlat),
            minlon: parseFloat(minlon),
            maxlat: parseFloat(maxlat),
            maxlon: parseFloat(maxlon),
        });

        const center = boundingRect.getCenter();

        return center;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to obtain centroid from search cookie', e);
        return null;
    }
};

export const getUserSearchContextFromSearchCookie = (
    cookie: string
): 'FOR_SALE' | 'FOR_RENT' | 'SOLD' => {
    const valuePattern = '([01])';
    const forSalePattern = new RegExp(`fs=${valuePattern}`);
    const forRentPattern = new RegExp(`fr=${valuePattern}`);
    const soldPattern = new RegExp(`rs=${valuePattern}`);

    const [isForSale, isForRent, isRecentlySold] = [
        forSalePattern,
        forRentPattern,
        soldPattern,
    ].map((pattern) => pattern.exec(cookie)?.[1] === '1');

    if (isForSale) {
        return 'FOR_SALE';
    }
    if (isForRent) {
        return 'FOR_RENT';
    }
    if (isRecentlySold) {
        return 'SOLD';
    }
    return 'FOR_SALE';
};
